// extracted by mini-css-extract-plugin
export default {"contents":"RE-z","sectionHeading":"SE-z"};